<div class="container container-small my-5">
    <h1>Gebruiker {{user ? user.id ? 'aanpassen' : 'toevoegen' : 'laden...'}}</h1>
    <div *ngIf="form" [formGroup]="form">
        <div class="d-flex flex-row gap-3">
            <mat-form-field appearance="fill">
                <mat-label>E-mailadres</mat-label>
                <input [formControl]="formControls.email" matInput />
                <mat-error [control]="formControls.email"></mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Naam</mat-label>
                <input [formControl]="formControls.name" matInput />
                <mat-error [control]="formControls.name"></mat-error>
            </mat-form-field>
        </div>
        <ng-select [closeOnSelect]="false" [hideSelected]="true" [items]="roles" [multiple]="true" bindLabel="name" class="wrap" bindValue="key" formControlName="roles" name="roles" placeholder="Gebruikersrollen">
            <ng-template ng-option-tmp let-item=item>
                <span [class.text-decoration-line-through]="!(item.key | hasRole) && !(Roles.Codalt | hasRole)">{{item.name}}</span>
                <small *ngIf="!(item.key | hasRole) && !(Roles.Codalt | hasRole)" class="ps-3">Deze rol heb je zelf niet</small>
            </ng-template>
        </ng-select>

        @if (user?.customers) {
            <div class="d-flex flex-row gap-3">
                @for(customer of user.customers; track customer) {
                    <mat-chip>
                        <i class="fa-solid fa-building me-1"></i> {{customer.name}}
                    </mat-chip>
                }
            </div>
        }

        <div class="mt-3">
            <mat-checkbox [formControl]="formControls.email_ticket_notifications">
                E-mailnotificaties ontvangen voor TVM-tickets
            </mat-checkbox>
            <div class="text-muted small mt-1">
                Ontvang e-mails bij nieuwe tickets of opmerkingen op tickets waar u bij betrokken bent
            </div>
        </div>
        <div class="d-flex justify-content-between pt-3 mb-4">
            <button class="mr-2" color="accent" mat-stroked-button routerLink="/{{Routenames.Users}}">
                Annuleren
            </button>
            @if (Features.AuthLoginAsUserSave | hasFeature){
                <button mat-stroked-button color="warn" (click)="loginAs()" *ngIf="user?.id">
                    Inloggen als deze gebruiker
                </button>
            }
            <button (click)="save()" color="accent" mat-flat-button>Opslaan</button>
        </div>
    </div>
</div>
